export const gitCommit = 'd6f58a8c'
